<template>
  <v-card
    max-width="750"
    class="mx-auto"
    color="grey-lighten-3"
    :disabled="loading"
    :loading="loading"
  >
    <v-layout>
      <CustomAppBar :page="8" :title="$t('info_card.title_page8')" />
      <v-main>
        <v-card-text class="px-0 px-md-3 px-xl-6">
          <v-chip :color="isUploadedPhoto ? 'green' : 'red'" class="ml-3 mb-5">
            <h2 class="mr-2">{{ $t("upload_photo.status") }}:</h2>
            <h2>
              {{
                isUploadedPhoto
                  ? $t("upload_photo.uploaded")
                  : $t("upload_photo.not_upload")
              }}
            </h2>
          </v-chip>

          <v-card class="mb-3">
            <v-card-title>{{ $t("upload_photo.example") }}</v-card-title>
            <v-card-text v-if="level_id == '1'">
              <v-img
                :src="
                  $root.$i18n.locale === 'en'
                    ? 'https://www.reg.kmitl.ac.th/storage/kmitl1/info/photo/1-en.jpg'
                    : 'https://www.reg.kmitl.ac.th/storage/kmitl1/info/photo/1-th.jpg'
                "
              >
              </v-img>
              <v-img
                :src="
                  $root.$i18n.locale === 'en'
                    ? 'https://www.reg.kmitl.ac.th/storage/kmitl1/info/photo/2-en.jpg'
                    : 'https://www.reg.kmitl.ac.th/storage/kmitl1/info/photo/2-th.jpg'
                "
              >
              </v-img>
            </v-card-text>
            <v-card-text v-else>
              <a
                href="https://www.reg.kmitl.ac.th/storage/kmitl1/info/graduate/info4_th.pdf"
                target="_blank"
              >
                <v-btn
                  class="mb-1 float-right"
                  color="error"
                  variant="outlined"
                  prepend-icon="mdi-file-pdf-box"
                  elevation="0"
                >
                  {{ $t("upload.view_file") }}
                </v-btn>
              </a>
              <embed
                src="https://www.reg.kmitl.ac.th/storage/kmitl1/info/graduate/info4_th.pdf"
                width="100%"
                height="500px"
                type="application/pdf"
              />
            </v-card-text>
          </v-card>

          <p class="bg-red-lighten-5 text-red mb-1" v-if="comment != ''">
            {{ $t("upload_photo.correction_details") }}: <b>{{ comment }}</b>
          </p>

          <div class="text-center mb-2">
            <PrimeVueImage :src="imageSrc" v-if="isUploadedPhoto && imageSrc" />
          </div>

          <p class="bg-red-lighten-5 text-red mb-1" v-if="comment != ''">
            {{ $t("upload_photo.correction_details") }}: <b>{{ comment }}</b>
          </p>

          <PrimeVueUpload
            accept="image/jpeg"
            :fileLimit="1"
            :callback="upload"
            :key="rand"
            v-if="!isLockedPhoto"
          />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text
          ><div
            class="text-end mb-2 text-red"
            v-if="is_saved_before_page === false"
          >
            {{ $t("info.have_not_fill_page_before") }}
          </div>
          <div class="text-end">
            <v-btn color="primary" size="large" class="mr-2" to="/page7"
              >Back</v-btn
            >
            <v-btn
              color="primary"
              size="large"
              to="/page9"
              :disabled="!isUploadedPhoto || is_saved_before_page === false"
              >{{ isLockedPhoto === true ? "Next" : "Save & Next" }}</v-btn
            >
          </div></v-card-text
        >
      </v-main>
    </v-layout>
  </v-card>
</template>

<script>
import CustomAppBar from "@/components/info_cards/CustomAppBar.vue";
import PrimeVueImage from "@/components/info_cards/PrimeVueImage.vue";
import PrimeVueUpload from "@/components/info_cards/PrimeVueUpload.vue";
import UploadProvider from "@/services/upload.provider";

const uploadProvider = new UploadProvider();

export default {
  name: "PageEight",

  components: {
    CustomAppBar,
    PrimeVueImage,
    PrimeVueUpload,
  },

  data: () => ({
    loading: false,
    rand: null,
    imageSrc: null,
    is_saved_before_page: false,
  }),

  computed: {
    is_authorized_officer() {
      return this.$store.state.user.is_authorized_officer;
    },

    uid() {
      return this.$store.state.user.surrogated_student_uid;
    },

    surrogated_student_info() {
      return this.$store.state.user.surrogated_student_info;
    },

    isUploadedPhoto() {
      return (
        this.surrogated_student_info &&
        this.surrogated_student_info.UPLOAD_STUDENT_CARD_PHOTO_STATUS === "1"
      );
    },

    isLockedPhoto() {
      return (
        this.surrogated_student_info &&
        this.surrogated_student_info.LOCK_PHOTO === "1"
      );
    },

    comment() {
      return this.surrogated_student_info.COMMENT_PHOTO;
    },

    level_id() {
      return this.surrogated_student_info.LEVEL_ID;
    },
  },

  methods: {
    async fetchData() {
      this.loading = true;

      if (this.imageSrc) {
        window.URL.revokeObjectURL(this.imageSrc);
        this.rand = Math.random();
      }

      const data = await uploadProvider
        .getStudentCardPhoto({ uid: this.uid, rand: this.rand })
        .catch((error) => {
          error.response.data.text().then((text) => {
            this.$toast.error(text);
          });
          this.loading = false;
        });
      if (data) {
        this.imageSrc = window.URL.createObjectURL(data);
      }

      this.loading = false;
    },

    async upload(files) {
      this.loading = true;

      const result = await uploadProvider
        .uploadStudentCardPhoto({ uid: this.uid, file: files[0] })
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });

      if (result && result.status === true) {
        this.$toast.success(this.$t("toast.upload_successfully"));
        await this.$store.dispatch("user/getUserInfo");
        this.fetchData();
      } else this.$toast.error(this.$t("toast.cannot_upload_file"));
    },
  },

  async created() {
    await this.$store.dispatch("user/getUserInfo");
    this.is_saved_before_page =
      this.surrogated_student_info.ENTERED.includes("7");
    if (this.is_saved_before_page === false) {
      this.$router.push("/main");
    }

    if (this.isUploadedPhoto) this.fetchData();
  },
};
</script>

<style scoped></style>
